module.exports = __webpack_public_path__ + "img/suporte-02.3a401594.jpg";